module.exports = __webpack_public_path__ + "media/images/p-about/feature/icon1-f5402adbef5b1a9272e08131f6caee96.svg";